var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"elevation-3"},[_c('v-card-title',{staticClass:"body-1"},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.ENFORCEMENT.PARKING_FINE'))+" "+_vm._s(_vm.id)+" "),_c('v-spacer'),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-close")])],1)],1),(_vm.selectedParkingFine)?_c('v-card-text',[(_vm.selectedParkingFine)?_c('parking-fine-details',{attrs:{"parking-fine":_vm.selectedParkingFine}}):_vm._e(),(
          _vm.selectedParkingFine &&
            _vm.selectedParkingFine.newParkingFineNumber > 0 &&
            _vm.selectedParkingFine.newParkingFine
        )?_c('div',{staticClass:"border-bottom",staticStyle:{"border":"1px solid #D9D9D9"}}):_vm._e(),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-data-table',{attrs:{"headers":[
              {
                text: _vm.$vuetify.lang.t(
                  '$vuetify.ENFORCEMENT.PARKING_FINE_INVOICE_NUMBER'
                ),
                align: 'start',
                sortable: false,
                value: 'invoiceNumber'
              },
              {
                text: _vm.$vuetify.lang.t(
                  '$vuetify.ENFORCEMENT.PARKING_FINE_INVOICE_DATE'
                ),
                align: 'start',
                sortable: false,
                value: 'createdAt'
              },
              {
                text: _vm.$vuetify.lang.t(
                  '$vuetify.ENFORCEMENT.PARKING_FINE_AMOUNT'
                ),
                align: 'start',
                sortable: false,
                value: 'amountInCents'
              },
              {
                text: 'Pdf',
                align: 'start',
                sortable: false,
                value: 'PDF'
              }
            ],"items":_vm.selectedParkingFine.invoices,"hide-default-footer":""},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$vuetify.lang.t( '$vuetify.ENFORCEMENT.PARKING_FINE_INVOICES' )))])],1)]},proxy:true},{key:"item.createdAt",fn:function(props){return [_c('td',[_vm._v(" "+_vm._s(_vm.dateEE(props.item.createdAt))+" ")])]}},{key:"item.amountInCents",fn:function(props){return [_c('td',[_vm._v(" "+_vm._s(props.item.amountInCents / 100)+_vm._s(props.item.currency)+" ")])]}},{key:"item.PDF",fn:function(props){return [_c('td',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.downloadPDF(props.item)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-file-pdf-box")]),_vm._v(" parking-fine-"+_vm._s(props.item.invoiceNumber)+" ")],1)],1)]}}],null,false,4130847787)})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('v-data-table',{attrs:{"headers":[
              {
                text: _vm.$vuetify.lang.t(
                  '$vuetify.ENFORCEMENT.PARKING_FINE_INVOICE_DATE'
                ),
                align: 'start',
                sortable: false,
                value: 'CreatedAt'
              },
              {
                text: _vm.$vuetify.lang.t('$vuetify.ENFORCEMENT.COMMENT'),
                align: 'start',
                sortable: false,
                value: 'Comment'
              }
            ],"items":_vm.selectedParkingFine.commentsArray,"hide-default-footer":""},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.ENFORCEMENT.COMMENTS')))])],1)]},proxy:true},{key:"item.CreatedAt",fn:function(props){return [_c('td',[_vm._v(" "+_vm._s(_vm.dateEE(props.item.CreatedAt))+" ")])]}},{key:"item.Comment",fn:function(props){return [_c('td',[_vm._v(" "+_vm._s(props.item.Comment)+" ")])]}}],null,false,1634507736)})],1)],1)],1):_vm._e(),(_vm.loading.state && _vm.loading.type === 'getParkingFine')?_c('v-toolbar',{staticClass:"elevation-0"},[_c('v-spacer'),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"secondary"}}),_c('v-spacer')],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }